import apiClient from './client';

// =============================================
// Budget Types
// =============================================
export interface BudgetCategory {
  id: string;
  name: string;
  icon?: string;
  color?: string;
}

export interface Budget {
  id: string;
  user_id: string;
  category_id: string | null;
  category?: BudgetCategory | null;
  amount: number | string; // Backend gibt Decimal als String
  period: 'monthly' | 'weekly';
  spent?: number | string;
  created_at: string;
  updated_at?: string;
}

export interface BudgetStatus {
  id: string;
  category_id: string | null;
  category_name: string;
  amount: number | string;
  spent: number | string;
  percentage: number | string;
  period: 'monthly' | 'weekly';
}

export interface BudgetStatusResponse {
  budgets: BudgetStatus[];
  total_budget: number | string;
  total_spent: number | string;
  total_percentage: number | string;
}

export interface BudgetCreateRequest {
  amount: number;
  period: 'monthly' | 'weekly';
  category_id?: string | null;
}

export interface BudgetUpdateRequest {
  amount?: number;
  period?: 'monthly' | 'weekly';
  category_id?: string | null;
}

// =============================================
// Budgets API
// =============================================
export const budgetsApi = {
  list: async (): Promise<Budget[]> => {
    const response = await apiClient.get<Budget[]>('/budgets');
    return response.data;
  },

  create: async (data: BudgetCreateRequest): Promise<Budget> => {
    const response = await apiClient.post<Budget>('/budgets', data);
    return response.data;
  },

  update: async (id: string, data: BudgetUpdateRequest): Promise<Budget> => {
    const response = await apiClient.put<Budget>(`/budgets/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/budgets/${id}`);
  },

  getStatus: async (): Promise<BudgetStatusResponse> => {
    const response = await apiClient.get<BudgetStatusResponse>('/budgets/status');
    return response.data;
  },
};
